
import { Navigation } from "@/components/Navigation";
import { Categories } from "@/components/Categories";
import { PollList } from "@/components/PollList";
import { Footer } from "@/components/Footer";
import { useQuery } from "@tanstack/react-query";
import { Poll, PollStatus } from "@/types/Poll";
import {SEO} from "@/components/SEO.tsx";
import React, {useState} from "react";
import {Session} from "@supabase/supabase-js";
import {useAuth} from "@/contexts/AuthContext.tsx";

const Polls = () => {
    /*const [userSession] = useState<Session | null>(() => {
        const cachedSession = localStorage.getItem('session');
        return cachedSession ? JSON.parse(cachedSession) : null;
    });*/
    const {user, session, loading} = useAuth();
    const { data: polls, isLoading, refetch } = useQuery({
        queryKey: ['polls',session],
        queryFn: async () => {
            const headers = {
                Authorization: `Bearer ${session?.access_token}`
            }
            const response = await fetch(`${import.meta.env.VITE_API_URL}/polls`, {
                method: 'GET',
                headers: session?.access_token ? headers : {},
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data: Poll[] = await response.json();
            const activePolls = data.filter(poll => parseInt(poll.status.toString()) === PollStatus.active);
            // console.log("API responses:", activePolls)
            return activePolls;
        }
    });

    return (
        <div className="min-h-screen bg-background">
            <SEO
                title="Polls"
                description="Explore trending and featured polls across all categories"
                type="website"
                name="blankpoll"
                imageUrl="/blankpoll-banner.jpg"
            />
            <Navigation />
            <Categories />
            <main className="pt-24 bg-background">
                <div className="text-center mb-8">
                    <h2 className="text-2xl font-bold text-secondary dark:text-white">All Polls</h2>
                    <p className="text-gray-600 dark:text-gray-300 mt-2">Explore and participate in ongoing polls across all categories</p>
                </div>
                {isLoading ? (
                    <div className="max-w-7xl mx-auto px-4">
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-12">
                            {[1, 2, 3, 4].map((i) => (
                                <div key={i} className="h-64 bg-gray-100 dark:bg-gray-800 rounded-lg animate-pulse" />
                            ))}
                        </div>
                    </div>
                ) : (
                    <PollList refetch={refetch} isLoading={isLoading} polls={polls} />
                )}
            </main>
            <Footer />
        </div>
    );
};

export default Polls;
